export default {
      id: "heavy-arrow-left-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "sprite-46b249.svg#heavy-arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }